<div class="dialog-container">
  <h1 mat-dialog-title>{{ 'pdp.attractionOptions' | cxTranslate }}</h1>
  <mat-divider class="mb-4"></mat-divider>
  <div class="dialog-content">
    @if (attractions$ | async; as data) {
      <div class="product-list">
        <!-- mat-dialog-content  -->
        @for (product of data.products; track product) {
          <udx-cx-attraction-card-component
            [product]="product"
            [allProducts]="data.products!"
            (onSelectCardEvent)="onSelectCardEvent($event)"
          ></udx-cx-attraction-card-component>
        }
      </div>
    }
  </div>

  <mat-dialog-actions align="center" class="usj dialog-actions my-2">
    <button class="btn btn-secondary close-button m-1" mat-button mat-dialog-close>{{ 'pdp.close' | cxTranslate }}</button>
    <button class="btn btn-primary confirm-button m-1" mat-button [mat-dialog-close]="selectedAttraction.code" cdkFocusInitial
    [disabled]="!isAttractionSelected">{{ 'pdp.confirm' | cxTranslate }}</button>
  </mat-dialog-actions>
</div>
